// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/responsive.css
// module id = 2133
// module chunks = 0